module.exports = __webpack_public_path__ + "static/5-f505dfbd06640c2b2ef8b79af72b138a.jpg";